<template>
  <div class="summary-card" :title="tooltipText">
    <div class="card-icon-wrap">
      <b-icon :icon="icon" size="is-small" custom-class="card-fa-icon" />
    </div>
    <div class="card-info">
      <p class="card-label">{{ text }}</p>
      <p class="card-value">R$ {{ formatMoney(value) }}</p>
    </div>
  </div>
</template>

<script>
import { mask } from "../../../mixins/mask";

export default {
  props: {
    tooltipText: String,
    text: String,
    icon: { type: String, default: "coins" },
    value: { type: Number, default: 0 },
    percentage: { type: [Number, String], default: null }
  },
  mixins: [mask]
};
</script>

<style scoped>
.summary-card {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  background: #fff;
  border: 1px solid #efefef;
  border-radius: 10px;
  padding: 0.7rem 0.85rem;
  flex: 0 0 calc((100% - 1rem) / 3);
  min-width: 0;
}

.card-icon-wrap {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ff924c, #ff5c1a);
}

.card-icon-wrap ::v-deep .icon,
.card-icon-wrap ::v-deep svg {
  color: #fff !important;
  fill: #fff !important;
}

.card-info {
  overflow: hidden;
}

.card-label {
  font-size: 0.72rem;
  color: #888;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 0.1rem;
  line-height: 1.2;
}

.card-value {
  font-size: 0.9rem;
  font-weight: 700;
  color: #222;
  white-space: nowrap;
  line-height: 1.3;
}
</style>
